import { BooleanHelper } from "../../../utilities/contracts/boolean-helper";

export class MemberDataLoadState {
  dataLoadId: string;
  fileName: string;
  displaySummary: boolean;
  isLoadProcess: boolean;
  isValidationComplete: boolean;
  isFileHeaderError: boolean;

  constructor(options: Partial<MemberDataLoadState> = {}) {
    this.dataLoadId = options.dataLoadId;
    this.displaySummary = BooleanHelper.tryGet(options.displaySummary, false);
    this.isFileHeaderError = BooleanHelper.tryGet(options.isFileHeaderError, false);
    this.isLoadProcess = BooleanHelper.tryGet(options.isLoadProcess, false);
    this.isValidationComplete = options.isValidationComplete;
    this.fileName = options.fileName;
  }

}
